/**
 * Fontes do configurador.
 *
 * Duas origens: as EMBUTIDAS (pilhas de fontes do sistema, sempre disponíveis)
 * e as ENVIADAS pelo admin no painel. Nos dois casos o que vai para o CSS é a
 * `family` — e ela nunca é o nome digitado pelo admin: fonte enviada recebe um
 * nome interno derivado do id, para que nenhum caractere do nome de exibição
 * chegue a um `font-family`.
 */

export interface CatalogFont {
  id: string;
  /** Nome exibido ao admin e ao cliente. */
  label: string;
  /** Valor de `font-family`, já terminado em uma família genérica. */
  family: string;
}

/**
 * Lista fechada porque o nome da família é uma string que o navegador aceita
 * calado: uma fonte que não existe na máquina de quem VÊ a loja não dá erro —
 * o texto só aparece em outra fonte. Toda entrada termina em uma família
 * genérica pelo mesmo motivo.
 */
export const BUILTIN_FONTS: CatalogFont[] = [
  {
    id: "archivo-black",
    label: "Archivo Black",
    family: "'Archivo Black', 'Arial Black', Impact, sans-serif",
  },
  { id: "impact", label: "Impact", family: "Impact, 'Arial Black', sans-serif" },
  { id: "arial-black", label: "Arial Black", family: "'Arial Black', Arial, sans-serif" },
  { id: "arial", label: "Arial", family: "Arial, Helvetica, sans-serif" },
  { id: "georgia", label: "Georgia", family: "Georgia, 'Times New Roman', serif" },
  { id: "courier-new", label: "Courier New", family: "'Courier New', monospace" },
];

/** Nome interno de uma fonte enviada — o que o `@font-face` registra. */
export const customFontName = (id: string): string => `mbf-${id}`;

/** `font-family` de uma fonte enviada. */
export const customFontFamily = (id: string): string => `'${customFontName(id)}', sans-serif`;
